var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.80625,
    y: 0.30625,
    width: 48.3875,
    height: 48.3875,
    rx: 24.1938,
    fill: "#F49F0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0206 15.4102C21.7106 15.4102 19.0206 18.1002 19.0206 21.4102V24.3002C19.0206 24.9102 18.7606 25.8402 18.4506 26.3602L17.3006 28.2702C16.5906 29.4502 17.0806 30.7602 18.3806 31.2002C22.6906 32.6402 27.3406 32.6402 31.6506 31.2002C32.8606 30.8002 33.3906 29.3702 32.7306 28.2702L31.5806 26.3602C31.2806 25.8402 31.0206 24.9102 31.0206 24.3002V21.4102C31.0206 18.1102 28.3206 15.4102 25.0206 15.4102Z",
    stroke: "white",
    strokeWidth: 1.225,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8699 15.6999C26.5599 15.6099 26.2399 15.5399 25.9099 15.4999C24.9499 15.3799 24.0299 15.4499 23.1699 15.6999C23.4599 14.9599 24.1799 14.4399 25.0199 14.4399C25.8599 14.4399 26.5799 14.9599 26.8699 15.6999Z",
    stroke: "white",
    strokeWidth: 1.225,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0195 31.5601C28.0195 33.2101 26.6695 34.5601 25.0195 34.5601C24.1995 34.5601 23.4395 34.2201 22.8995 33.6801C22.3595 33.1401 22.0195 32.3801 22.0195 31.5601",
    stroke: "white",
    strokeWidth: 1.225,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.80625,
    y: 0.30625,
    width: 48.3875,
    height: 48.3875,
    rx: 24.1938,
    stroke: "#F49F0A",
    strokeWidth: 0.6125
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dd1eea82cb5fbb5adad752782b7084e0.svg";
export { ForwardRef as ReactComponent };